import { APPCONFIG } from "./config";

type Feature = keyof typeof APPCONFIG.FEATURES;

export const isFeatureEnabled = (feature: Feature) => APPCONFIG.FEATURES[feature];
